import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/en';
import 'dayjs/locale/hr';

dayjs.extend(localizedFormat);

const normalizeLocale = (locale?: string) => {
  if (!locale) {
    return 'en';
  }

  if (locale.startsWith('hr')) {
    return 'hr';
  }

  return 'en';
};

export const formatDate = (date?: string | null, format = 'DD MMMM YYYY', locale?: string) => {
  if (!date) {
    return '';
  }

  const parsedDate = dayjs(date);
  if (!parsedDate.isValid()) {
    return '';
  }

  return parsedDate.locale(normalizeLocale(locale)).format(format);
};
